export default __webpack_public_path__ + "static/favicon-512-1759ffc9d98a05c501e73904cc5639da.png";